module.exports = __webpack_public_path__ + "static/media/hardDiskSvgrepoCom.c66ddcb3.svg";